import {useState} from 'react';

import {HomeDrawCreditFormOffRampValues} from "../../utils";
import {AvailableBalance} from "../../utils/creditService";

import HomeDrawCreditOffRampStep0 from "./HomeDrawCreditFormOffRampStep0";
import HomeDrawCreditFormOffRampStep1 from "./HomeDrawCreditFormOffRampStep1";

interface HomeDrawCreditFormOffRampProps {
  onCloseModal: () => void;
  handleBack: () => void;
  creditLine: AvailableBalance;
}

function HomeDrawCreditFormOffRamp(
  {
    onCloseModal,
    handleBack,
    creditLine
  }:HomeDrawCreditFormOffRampProps) {
  const [formData, setFormData] = useState<HomeDrawCreditFormOffRampValues>({
    amount: undefined,
    fiatCurrency: "usd",
    tokens: ["USDC", "BASE"],
    accountNumber: "",
    routingNumber: "",
    companyAddress: "",
    country: "",
    province: "",
    city: "",
    postalCode: "",
    selectedCreditLine: creditLine.id,
  })

  const [currentStep, setCurrentStep] = useState(0)

  const handleNextStep = (newFormData: HomeDrawCreditFormOffRampValues) => {
    setFormData(prev => ({...prev, ...newFormData}))

    if (currentStep === steps.length - 1) {
      alert(JSON.stringify(newFormData, null, 2))
    } else {
      setCurrentStep(prev => prev + 1)
    }
  }

  const handlePrevStep = (newFormData: HomeDrawCreditFormOffRampValues) => {
    setFormData(prev => ({...prev, ...newFormData}))
    setCurrentStep(prev => prev - 1)
  }

  const steps = [
    <HomeDrawCreditOffRampStep0
      data={formData}
      next={handleNextStep}
      handleBack={handleBack}
      onCloseModal={onCloseModal}
      creditLine={creditLine}
    />,

    <HomeDrawCreditFormOffRampStep1
      data={formData}
      prev={handlePrevStep}
      onCloseModal={onCloseModal}
    />,
  ]

  return (
    <>
      {steps[currentStep]}
    </>
  );
}

export default HomeDrawCreditFormOffRamp;